import React, { useContext, useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";

import SideBar from "./SideBar";
import Entradas from "./Entradas";
import Salidas from "./Salidas";
import Clientes from "./Clientes";
import Proveedores from "./Proveedores";
import AgregarFamilia from "./AgregarFamilia";
import AgregarTipo from "./AgregarTipo";
import AgregraMarca from "./AgregarMarca";
import AgregarModelo from "./AgregarModelo";
import CrearEquipo from "./CrearEquipo";
import Transaccion from "./ReporteMovimientosES";
import ServicioTecnico from "./ServicioTecnico";
import Protocolos from "./Protocolos";
import Mantenimiento from "./Mantenimiento";
import Configuracion from "./Configuracion";
import NavbarSesion, { NAV_HEIGHT } from "./NavbarSesion";
import AgregarEmpresa from "./AgregarEmpresa";
import ActualizaProveedor from "./ActualizaProveedor";
import { RegistroUsuarios } from "./RegistroUsuarios";
import ActualizaCliente from "./ActualizaCliente";
import ActualizaFamilia from "./ActualizaFamilia";
import ActualizaTipo from "./ActualizaTipo";
import ActualizaMarca from "./ActualizaMarca";
import ActualizaModelo from "./ActualizaModelo";
import ActualizaEmpresa from "./ActualizaEmpresa";
import DashboardEq from "./DashboardEq";
import AsignarRfid from "./AsignarRfid";
import ReporteHistoriaEquipo from "./ReporteHistoriaEquipo";
import ReporteHistoriaCliente from "./ReporteHistoriaCliente";
import ReporteStatus from "./ReporteStatus";
import ReporteMovimientos from "./ReporteMovimientosES";
import ReporteInvCliente from "./ReporteInvCliente";
import Reportes from "./Reportes";
import Confirmados from "./Confirmados";
import UsuariosEnvios from "./UsuariosAlertas";
import ActualizaUsuariosAlertas from "./ActualizaUsuariosAlertas";
import AgregarItems from "./AgregarItems";
import EjecutarMantencion from "./EjecutarMantencion";
import Bitacoras from "./Bitacoras";
import Traspasos from "./Traspasos";
import CheckMantoPDF from "./CheckMantoPDF";
import IngresoEquiposST from "./IngresoEquiposST";
import ItemsST from "./ItemsST";
import ProtocolosTest from "./ProtocolosTest";
import Asignar from "./Asignar";
import AsignadosTecnicos from "./AsignadosTecnicos";
import GenerarPresupuesto from "./GenerarPresupuesto";
import ProgramaMant from "./ProgramaMant";
import ListadoMant from "./ListadoMant";
import EjecutarMantencionSt from "./EjecutarMantencionSt";
import EjecutarPresupuestoSt from "./EjecutarPresupuestoSt";
import ReporteMantoPrev from "./ReporteMantoPrev";
import ReportePresu from "./ReportePresu";
import Entregar from "./Entregar";
import ActualizaItemsPrecio from "./ActualizaItemsPrices";
import ReportesST from "./ReportesST";
import EjecutarGarantia from "./EjecutarGarantia";
import ReporteGarantia from "./ReporteGarantia";
import Backoffice from "./BackOfice";
import EstadoTenantPage from "./EstadoTenatPage";
import ContratoMantencion from "./ContratoMantencion";
import AdminCatalogosEmpresa from "./AdminCatalogoEmpresa";
import UsuariosGlobales from "./UsuariosGlobales";
import ReporteMantencionesContrato from "../components/ReporteMantencionesContrato";
import GestionGarantiaExterna from "./GestionGarantiaExterna";
import ConsultaEquipos from "./ConsultarEquipos";

// ---------------------------------------------------------
// DASHBOARDS / PANELES POR DOMINIO
// ---------------------------------------------------------

import PanelOperativoAdminST from "./PanelOperativoST";
import PanelTrabajoTecnicoST from "./PanelTrabajoTecnico";

// ---------------------------------------------------------
// CONTEXTO
// ---------------------------------------------------------

import { UserContext } from "../context/UserContext";

// ---------------------------------------------------------
// FIREBASE / SESION
// ---------------------------------------------------------

import {
  signOut,
  onAuthStateChanged,
} from "firebase/auth";

import {
  updateDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";

import {
  auth,
  db,
} from "../firebase/firebaseConfig";

import { validateSession } from "../components/session";

// =========================================================
// PANTALLA INICIAL SEGUN ROL
// =========================================================

const InicioPorRol = () => {
  const { users } = useContext(UserContext);

  if (!users) {
    return null;
  }

  switch (users.rol) {

    // -----------------------------------------------------
    // BACKOFFICE
    // -----------------------------------------------------

    case "DADMIN":
    case "JADMIN":
      return (
        <Navigate
          to="/backofice/estado-tenant"
          replace
        />
      );

    // -----------------------------------------------------
    // HOMECARE
    // -----------------------------------------------------

    case "ADMIN-HC":
      return <DashboardEq />;

    case "SUPERVISOR-HC":
      return <Transaccion />;

    case "TRANSPORTE-HC":
      return (
        <Navigate
          to="/confirmados"
          replace
        />
      );

    // -----------------------------------------------------
    // LOGISTICMED ST
    // -----------------------------------------------------

    case "ADMIN-LMST":
      return <PanelOperativoAdminST />;

    case "TECNICO-LMST":
      return <PanelTrabajoTecnicoST />;

    // -----------------------------------------------------
    // ROL NO RECONOCIDO
    // -----------------------------------------------------

    default:
      return (
        <Navigate
          to="/login"
          replace
        />
      );
  }
};

// =========================================================
// PROTECCION DASHBOARD HOMECARE
// =========================================================
//
// DashboardEq es exclusivamente para ADMIN-HC.
//
// Evita que:
// - DADMIN
// - JADMIN
// - SUPERVISOR-HC
// - TRANSPORTE-HC
// - ADMIN-LMST
// - TECNICO-LMST
//
// puedan entrar manualmente escribiendo /misequipos.
// =========================================================

const SoloAdminHC = ({ children }) => {
  const { users } = useContext(UserContext);

  if (!users) {
    return null;
  }

  if (users.rol !== "ADMIN-HC") {
    return (
      <Navigate
        to="/home"
        replace
      />
    );
  }

  return children;
};

// =========================================================
// HOME
// =========================================================

export const Home = () => {

  const navigate = useNavigate();

  // =======================================================
  // VALIDACION DE SESION
  // =======================================================

  useEffect(() => {

    const unsubscribe = onAuthStateChanged(
      auth,
      async (user) => {

        if (!user) {
          navigate("/login");
          return;
        }

        const sesionValida =
          await validateSession(user);

        if (!sesionValida) {

          localStorage.setItem(
            "sessionExpired",
            "1"
          );

          localStorage.removeItem("email");
          localStorage.removeItem("uid");

          localStorage.removeItem(
            "logisticmed_session_id"
          );

          await signOut(auth);

          navigate("/login");
        }
      }
    );

    return () => unsubscribe();

  }, [navigate]);

  // =======================================================
  // ACTUALIZACION LAST ACTIVE
  // =======================================================

  useEffect(() => {

    const interval = setInterval(
      async () => {

        const user = auth.currentUser;

        if (user?.uid) {

          await updateDoc(
            doc(
              db,
              "sesionesUsuarios",
              user.uid
            ),
            {
              lastActive: serverTimestamp(),
            }
          );
        }

      },
      60000
    );

    return () => clearInterval(interval);

  }, []);

  // =======================================================
  // VALIDACION LOCALSTORAGE
  // =======================================================

  const storedUser =
    localStorage.getItem("users");

  if (!storedUser) {
    return (
      <Navigate
        to="/login"
        replace
      />
    );
  }

  // =======================================================
  // RENDER
  // =======================================================

  return (

    <div>

      <NavbarSesion />

      <SideBar
        navHeight={NAV_HEIGHT}
      >

        <Routes>

          {/* ================================================= */}
          {/* INICIO SEGUN ROL                                  */}
          {/* ================================================= */}

          <Route
            path="home"
            element={<InicioPorRol />}
          />

          {/* ================================================= */}
          {/* HOMECARE - DASHBOARD ADMINISTRATIVO              */}
          {/* ================================================= */}

          <Route
            path="misequipos"
            element={
              <SoloAdminHC>
                <DashboardEq />
              </SoloAdminHC>
            }
          />

          <Route
            path="misequipos/agregarfamilia"
            element={<AgregarFamilia />}
          />

          <Route
            path="actualizafamilia/:id"
            element={<ActualizaFamilia />}
          />

          <Route
            path="misequipos/agregartipo"
            element={<AgregarTipo />}
          />

          <Route
            path="actualizatipo/:id"
            element={<ActualizaTipo />}
          />

          <Route
            path="misequipos/agregarmarca"
            element={<AgregraMarca />}
          />

          <Route
            path="actualizamarca/:id"
            element={<ActualizaMarca />}
          />

          <Route
            path="misequipos/agregarmodelo"
            element={<AgregarModelo />}
          />

          <Route
            path="actualizamodelo/:id"
            element={<ActualizaModelo />}
          />

          <Route
            path="misequipos/crearequipo"
            element={<CrearEquipo />}
          />

          <Route
            path="misequipos/asignarfid"
            element={<AsignarRfid />}
          />

          {/* ================================================= */}
          {/* CLIENTES                                         */}
          {/* ================================================= */}

          <Route
            path="clientes"
            element={<Clientes />}
          />

          <Route
            path="actualizacliente/:id"
            element={<ActualizaCliente />}
          />

          {/* ================================================= */}
          {/* PROVEEDORES                                      */}
          {/* ================================================= */}

          <Route
            path="proveedores"
            element={<Proveedores />}
          />

          <Route
            path="actualizaproveedor/:id"
            element={<ActualizaProveedor />}
          />

          {/* ================================================= */}
          {/* TRANSACCIONES HOMECARE                            */}
          {/* ================================================= */}

          <Route
            path="transacciones"
            element={<Transaccion />}
          />

          <Route
            path="transacciones/entradas"
            element={<Entradas />}
          />

          <Route
            path="transacciones/salidas"
            element={<Salidas />}
          />

          <Route
            path="transacciones/traspasos"
            element={<Traspasos />}
          />

          <Route
            path="confirmados"
            element={<Confirmados />}
          />

          {/* ================================================= */}
          {/* REPORTES HOMECARE                                 */}
          {/* ================================================= */}

          <Route
            path="reportes"
            element={<Reportes />}
          />

          <Route
            path="reportes/reporte1"
            element={<ReporteHistoriaEquipo />}
          />

          <Route
            path="reportes/reporte2"
            element={<ReporteStatus />}
          />

          <Route
            path="reportes/reporte3"
            element={<ReporteHistoriaCliente />}
          />

          <Route
            path="reportes/reporte4"
            element={<ReporteMovimientos />}
          />

          <Route
            path="reportes/reporte5"
            element={<ReporteInvCliente />}
          />

          <Route
            path="reportes/consulta-equipo"
            element={<ConsultaEquipos />}
          />

          {/* ================================================= */}
          {/* MANTENCIONES HOMECARE                             */}
          {/* ================================================= */}

          <Route
            path="alertamantencion/programa"
            element={<ProgramaMant />}
          />

          <Route
            path="alertamantencion/listadomant"
            element={<ListadoMant />}
          />

          <Route
            path="alertamantencion/bitacoras"
            element={<ReporteMantencionesContrato />}
          />

          {/* ================================================= */}
          {/* SERVICIO TECNICO                                 */}
          {/* ================================================= */}

          <Route
            path="serviciotecnico"
            element={<ServicioTecnico />}
          />

          <Route
            path="serviciotecnico/items"
            element={<AgregarItems />}
          />

          <Route
            path="serviciotecnico/protocolos"
            element={<Protocolos />}
          />

          <Route
            path="serviciotecnico/mantencion"
            element={<Mantenimiento />}
          />

          <Route
            path="ejecutarmantencion/:id"
            element={<EjecutarMantencion />}
          />

          <Route
            path="serviciotecnico/bitacora"
            element={<Bitacoras />}
          />

          <Route
            path="checkmantencion/:id"
            element={<CheckMantoPDF />}
          />

          <Route
            path="serviciotecnico/ingreso"
            element={<IngresoEquiposST />}
          />

          <Route
            path="serviciotecnico/itemsst"
            element={<ItemsST />}
          />

          <Route
            path="serviciotecnico/protocolotest"
            element={<ProtocolosTest />}
          />

          <Route
            path="serviciotecnico/asignar"
            element={<Asignar />}
          />

          <Route
            path="serviciotecnico/asignadostecnicos"
            element={<AsignadosTecnicos />}
          />

          <Route
            path="serviciotecnico/actualizaitems/:id"
            element={<ActualizaItemsPrecio />}
          />

          <Route
            path="ejecutarmantencionst/:id"
            element={<EjecutarMantencionSt />}
          />

          <Route
            path="gestiongarantiaexterna/:id"
            element={<GestionGarantiaExterna />}
          />

          <Route
            path="presupuesto/:id"
            element={<GenerarPresupuesto />}
          />

          <Route
            path="ejecutarpresupuestost/:id"
            element={<EjecutarPresupuestoSt />}
          />

          <Route
            path="ejecutargarantia/:id"
            element={<EjecutarGarantia />}
          />

          <Route
            path="serviciotecnico/entregas"
            element={<Entregar />}
          />

          {/* ================================================= */}
          {/* REPORTES ST                                       */}
          {/* ================================================= */}

          <Route
            path="reportesst"
            element={<ReportesST />}
          />

          <Route
            path="reportesst/mantencionpreventiva"
            element={<ReporteMantoPrev />}
          />

          <Route
            path="reportesst/presupuestos"
            element={<ReportePresu />}
          />

          <Route
            path="reportesst/garantias"
            element={<ReporteGarantia />}
          />

          {/* ================================================= */}
          {/* CONFIGURACION                                     */}
          {/* ================================================= */}

          <Route
            path="configuracion"
            element={<Configuracion />}
          />

          <Route
            path="configuracion/registrausuarios"
            element={<RegistroUsuarios />}
          />

          <Route
            path="configuracion/envios"
            element={<UsuariosEnvios />}
          />

          <Route
            path="configuracion/actualizaalerta/:id"
            element={<ActualizaUsuariosAlertas />}
          />

          <Route
            path="configuracion/catalogos"
            element={<AdminCatalogosEmpresa />}
          />

          {/* ================================================= */}
          {/* BACKOFFICE                                        */}
          {/* ================================================= */}

          <Route
            path="backofice"
            element={<Backoffice />}
          />

          <Route
            path="backofice/agregarempresa"
            element={<AgregarEmpresa />}
          />

          <Route
            path="backofice/actualizaempresa/:id"
            element={<ActualizaEmpresa />}
          />

          <Route
            path="backofice/estado-tenant"
            element={<EstadoTenantPage />}
          />

          <Route
            path="backofice/contrato-mantencion"
            element={<ContratoMantencion />}
          />

          <Route
            path="backofice/usuarios"
            element={<UsuariosGlobales />}
          />

          {/* ================================================= */}
          {/* ROOT                                              */}
          {/* ================================================= */}

          <Route
            path="/"
            element={
              <Navigate
                to="/login"
                replace
              />
            }
          />

        </Routes>

      </SideBar>

    </div>
  );
};

export default Home;